.agl-ds-modal {
  &__container {
    max-height: 100% !important;
  }

  &__content {
    padding: 0 !important;

    @include agl-ds-screen-size('medium') {
      max-height: calc(100vh - 91px) !important;
    }

    .promo-dialog-content {
      > .trusted-content-container {
        overflow: hidden;
        height: auto;

        @include agl-ds-screen-size('small') {
          padding: 0 $space-02;
        }

        @include agl-ds-screen-size('medium') {
          padding: 0 $space-03;
        }
      }
    }

    .dialog-form {
      display: flex;
      flex-direction: column;
      gap: $space-00;
      padding-bottom: $space-02 !important;

      @include agl-ds-screen-size('small') {
        padding: $space-02;
      }

      @include agl-ds-screen-size('medium') {
        padding: $space-03;
      }

      .name-fields-container {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        @include agl-ds-screen-size('small') {
          flex-direction: column;

          .sc-agl-ds-textbox-s {
            width: 100%;
          }
        }

        @include agl-ds-screen-size('medium') {
          flex-direction: row;
          gap: $space-04;

          .sc-agl-ds-textbox-s {
            width: 50%;
          }
        }
      }
    }

    .terms-container {
      @include agl-ds-screen-size('small') {
        padding: $space-01 $space-02;

        .sc-agl-ds-checkbox {
          font-size: 12px !important;
        }

        .terms-error-label {
          color: $error;
          font-size: 12px;
        }
      }

      @include agl-ds-screen-size('medium') {
        padding: $space-01 $space-03;

        .sc-agl-ds-checkbox {
          font-size: 14px !important;
        }

        .terms-error-label {
          color: $error;
          font-size: 14px !important;
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid $c-neutral-03;
  padding: $space-03 $space-04;

  @include agl-ds-screen-size('small') {
    agl-ds-button {
      min-width: 100%;
    }
  }

  @include agl-ds-screen-size('medium') {
    justify-content: flex-end;

    agl-ds-button {
      min-width: 250px;
    }
  }
}

.error-container {
  padding: 0 $space-03;
  padding-top: $space-01;

  .error-card {
    @include agl-ds-screen-size('medium') {
      border-left: 8px $c-tertiary-04 solid;
    }

    .error-card-container {
      width: 100%;

      @include agl-ds-screen-size('small') {
        display: flex;
        gap: $space-02;
        padding: $space-02;
        padding-bottom: 0;
        flex-direction: column;
      }

      @include agl-ds-screen-size('medium') {
        gap: $space-01;
        padding: $space-03;
        padding-top: $space-04;
        padding-bottom: $space-01;
        flex-direction: row;
        align-items: center;

        .error-icon {
          margin-top: -($space-03);
        }
      }
    }
  }
}
